document.addEventListener('DOMContentLoaded', () => {
  const path = window.location.pathname;

  const map = {
    'help-home': 'help-home',
    'help-guarantee-all': 'help-guarantee-all',
    'money-back-guarantee': 'money-back-guarantee',
    'satisfaction-guarantee': 'satisfaction-guarantee',
    'clean-label-guarantee': 'clean-label-guarantee',
    'clean-label': 'clean-label',
    'return-policy': 'return-policy',
    'shipping-info': 'shipping-info',
    'faq-00-all': 'faq-00-all',
    'faq-01-system': 'faq-01-system',
    'faq-02-probiotic': 'faq-02-probiotic',
    'faq-03-enzyme': 'faq-03-enzyme',
    'faq-04-shipping': 'faq-04-shipping',
    'faq-05-account': 'faq-05-account',
    'faq-06-qc': 'faq-06-qc',
    'faq-07-affiliate': 'faq-07-affiliate',
    'faq-08-other': 'faq-08-other',
    terms: 'terms',
    privacy: 'privacy',
    disclaimers: 'disclaimers'

  };

  Object.entries(map).forEach(([key, slug]) => {
    if (path.includes(slug)) {
      document.querySelectorAll(`[data-help-link="${key}"]`)
        .forEach(link => {
          link.classList.remove('tw:text-slate-500');
          link.classList.add('tw:bg-gray-50', 'tw:text-cyan-600');
          link.setAttribute('aria-current', 'page');
        });
    }
  });
});


document.addEventListener('click', (e) => {
  const btn = e.target.closest('[data-toggle]');
  if (!btn) return;

  e.preventDefault();
  e.stopPropagation();

  const key = btn.dataset.toggle;
  const panel = document.querySelector(`[data-panel="${key}"]`);
  if (!panel) return;

  const open = btn.getAttribute('aria-expanded') === 'true';

  btn.setAttribute('aria-expanded', String(!open));
  panel.classList.toggle('tw:hidden', open);
});
